


















































































































import Vue from "vue";
import NavigationButton from "@/components/navigation-button/NavigationButton.vue";

export default Vue.extend({
  name: "Navigation",
  components: {
    NavigationButton // 注册导航按钮组件
  },
  data() {
    return {
      showMenu: false, // 控制移动端侧边菜单显示/隐藏
      showNavbar: true, // 控制桌面端导航栏滚动显示/隐藏
      lastScrollPosition: 0, // 滚动位置记录（用于导航栏显示逻辑）
      mobileDropdownIndex: -1, // 控制移动端子导航展开/折叠（-1=全部关闭）
      routes: [
        { link: "/home", name: "Home" },
        { link: "/platforms", name: "Platforms" },
        { link: "/news", name: "News" },
        { link: "/team", name: "Team" },
        { link: "/pipeline", name: "Pipeline" },
        { link: "/disease-education", name: "Patient / ROSAH Disease Education" },
        // 核心子导航配置：Clinical Trials下含EAP政策子项
        {
          link: "/clinical-trials",
          name: "Healthcare Professionals / Clinical Trials",
          children: [
            { 
              link: "/clinical-trials/expanded-access-policy", 
              name: "Expanded Access Policy" 
            }
          ]
        },
        { link: "/publications", name: "Publications" },
        { link: "/careers", name: "Careers" }
      ]
    };
  },
  mounted() {
    // 监听滚动事件，控制桌面端导航栏显示/隐藏
    window.addEventListener("scroll", this.scrollY);
  },
  beforeDestroy() {
    // 销毁前移除滚动监听，避免内存泄漏
    window.removeEventListener("scroll", this.scrollY);
  },
  methods: {
    // 切换移动端侧边菜单显示/隐藏
    toggleShowMenu() {
      this.showMenu = !this.showMenu;
      this.mobileDropdownIndex = -1; // 关闭所有子导航
    },
    // 移动端菜单项点击后关闭菜单
    routeChanged() {
      this.showMenu = false;
      this.mobileDropdownIndex = -1;
    },
    // 桌面端导航栏滚动逻辑：上滚显示，下滚隐藏
    scrollY() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScrollPosition < 0) return;
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      this.lastScrollPosition = currentScrollPosition;
    },
    // 跳转首页（点击logo）
    navigateToHome() {
      if (this.$router.currentRoute.name === "home") return;
      this.$router.push("/home");
    },
    // 移动端展开/折叠子导航（Clinical Trials）
    toggleMobileDropdown(index: number) {
      this.mobileDropdownIndex = this.mobileDropdownIndex === index ? -1 : index;
    }
  }
});
